import { WallType } from "building-types/walls/wallEnums";
import type { SolidWall, SolidWallMass, Wall } from "building-types/walls/wallTypes";

export function isSolidWall(wall: Wall): wall is SolidWall {
  return wall.wallType === WallType.SOLID;
}

export function isSolidWallMass(wall: Wall): wall is SolidWallMass {
  return wall.wallType === WallType.SOLID_MASS;
}

export function wallIsSolid(wall: Wall): wall is SolidWallMass | SolidWall {
  return isSolidWallMass(wall) || isSolidWall(wall);
}
